<template>
	<v-col class="history-bonus">
		<div class="d-flex justify-space-between">
			<div class="font-size-14 font-weight-bold secondary--text">Stok Serial</div>
		</div>
		<div class="mt-5">
			<v-row>
				<v-col cols="12">
					<v-card class="pa-3 elevation-0 rounded-xl hover-shadow">
						<v-tabs class="tabs-vo no-slider">
							<v-tab class="rounded-xl" :disabled="tabDisabled" @click="changeTabSerial('ceria')">Serial Ceria</v-tab>
							<v-tab class="rounded-xl" :disabled="tabDisabled" @click="changeTabSerial('ekonomi')">Serial Ekonomis</v-tab>
							<v-tab class="rounded-xl" :disabled="tabDisabled" @click="changeTabSerial('star')">Serial Premium</v-tab>
							<v-tab class="rounded-xl" :disabled="tabDisabled" @click="changeTabSerial('supreme')">Serial Supreme</v-tab>
							<v-tab class="rounded-xl" :disabled="tabDisabled" @click="changeTabSerial('elite')">Serial Free</v-tab>
							<!-- <v-tab class="rounded-xl" :disabled="tabDisabled" @click="changeTabSerial('ro')">Serial Repeat Order</v-tab> -->
						</v-tabs>
					</v-card>
				</v-col>
			</v-row>
			<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
				<div class="pt-6" v-if="showSerial === 'star'">
					<SerialStar></SerialStar>
				</div>
			</v-scroll-x-reverse-transition>
			<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
				<div class="pt-6" v-if="showSerial === 'elite'">
					<SerialElite></SerialElite>
				</div>
			</v-scroll-x-reverse-transition>
			<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
				<div class="pt-6" v-if="showSerial === 'ekonomi'">
					<SerialEkonomi></SerialEkonomi>
				</div>
			</v-scroll-x-reverse-transition>
			<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
				<div class="pt-6" v-if="showSerial === 'ceria'">
					<SerialCeria></SerialCeria>
				</div>
			</v-scroll-x-reverse-transition>
			<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
				<div class="pt-6" v-if="showSerial === 'supreme'">
					<SerialSupreme></SerialSupreme>
				</div>
			</v-scroll-x-reverse-transition>
			<!-- <v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
				<div class="pt-6" v-if="showSerial === 'ro'">
					<SerialRO></SerialRO>
				</div>
			</v-scroll-x-reverse-transition> -->
		</div>
	</v-col>
</template>

<script>
import SerialStar from './SerialStar';
import SerialElite from './SerialElite';
import SerialEkonomi from './SerialEkonomi';
import SerialCeria from './SerialCeria';
import SerialSupreme from './SerialSupreme';
// import SerialRO from './SerialRO';

export default {
	components: {
		SerialStar, SerialElite, SerialEkonomi, SerialCeria, SerialSupreme
	},
	data() {
		return {
			showSerial: 'star',
			tabDisabled: false,
		}
	},
	methods: {
		changeTabSerial(type) {
			this.showSerial = type
			this.tabDisabled = true
			setTimeout(() => {
				this.tabDisabled = false
			}, 500)
		},
	},
	created(){
		this.$store.dispatch('setPageTitle', `Stok Serial`)
	}
};
</script>